import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { FeatureFlagService } from '@shared/services/feature-flag/feature-flag.service';
import { FeatureFlags } from '@shared/services/feature-flag/feature-flags';
import { PermissionQuery } from '@shared/services/feature-flag/permission-expr';
import { firstValueFrom } from 'rxjs';

export const FeatureFlagGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const query: FeatureFlags | PermissionQuery = route.data['featureFlag'];

  const isValidQuery = query instanceof PermissionQuery || Object.values(FeatureFlags).includes(query as FeatureFlags);
  if (!isValidQuery) {
    return false;
  }

  const featureService = inject(FeatureFlagService);

  // avoid getting the default false
  await featureService.waitUntilReady();

  return firstValueFrom(featureService.getPermission(query));
};
